// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"db37a9d8","455":"7d5bd38e","977":"0716ea47"}[chunkId] + ".chunk.js";
};